// 메시지 날짜 헬퍼 — 백엔드는 'Z' 없는 ISO(UTC naive) 저장 → UTC로 간주해 KST로 변환(fmtMsgTime과 동일 규약).
function _toDate(iso) {
  if (!iso) return null;
  const s = /Z$|[+-]\d\d:?\d\d$/.test(iso) ? iso : iso + 'Z';
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}

// 비교용 KST 날짜 키('YYYY-MM-DD'). 날짜 구분선 삽입 판정에 사용.
export function kstDateKey(iso) {
  const d = _toDate(iso);
  if (!d) return '';
  // en-CA 로캘 = YYYY-MM-DD 형식
  return d.toLocaleDateString('en-CA', { timeZone: 'Asia/Seoul' });
}

// 표시용 KST 날짜('2026년 6월 20일 (금)').
export function fmtMsgDate(iso) {
  const d = _toDate(iso);
  if (!d) return '';
  return d.toLocaleDateString('ko-KR', { timeZone: 'Asia/Seoul', year: 'numeric', month: 'long', day: 'numeric', weekday: 'short' });
}

// 메시지 시각 표시(KST, 'MM/DD HH:mm'). 'Z' 없는 ISO는 UTC로 간주(백엔드 UTC naive 저장).
export function fmtMsgTime(iso) {
  const d = _toDate(iso);
  if (!d) return '';
  return d.toLocaleString('ko-KR', { timeZone: 'Asia/Seoul', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false });
}
